import { combineReducers } from 'redux';
import { requests } from './requests';

export const Requests = combineReducers({
  requests
});
